const TOKEN_KEY = "pio_app_token";
const STATE_KEY = "pio_eve_state";

export function getAppToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAppToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearAppToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated(): boolean {
  return getAppToken() !== null;
}

export function generateState(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function rememberState(state: string): void {
  sessionStorage.setItem(STATE_KEY, state);
}

export function consumeState(): string | null {
  const state = sessionStorage.getItem(STATE_KEY);
  sessionStorage.removeItem(STATE_KEY);
  return state;
}

export function buildAuthorizeUrl(
  authorizeUrl: string,
  clientId: string,
  callbackUrl: string,
  scopes: string[],
  state: string,
): string {
  const params = new URLSearchParams({
    response_type: "code",
    redirect_uri: callbackUrl,
    client_id: clientId,
    scope: scopes.join(" "),
    state,
  });
  return `${authorizeUrl}?${params.toString()}`;
}
